import { ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive';

import { Button, Modal, Typography } from '../../designComponents';
import { ModalBody, ModalChildern } from './style';

type Props = {
  title?: string;
  message: string;
  children?: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  onOk?: () => void;
  okText?: string;
  cancelText?: string;
  loading?: boolean;
};

const ConfirmationModal = ({
  message,
  title,
  children,
  isOpen = false,
  onClose,
  okText = 'Sure',
  onOk,
  cancelText = 'Cancel',
  loading = false,
}: Props) => {
  const is767 = useMediaQuery({ query: ' (max-width : 767px)' });

  const handleOnClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      onClose={handleOnClose}
      open={isOpen}
      isFullWidth={false}
      style={{
        height: 'auto',
        maxWidth: 600,
        width: is767 ? '95%' : '600px',
        background: '#F0F0F0',
      }}
      isCentered={true}
      title={title}
      disableBackdropClick
    >
      {
        <ModalBody>
          <Typography variant="title" className="title">
            {message}
          </Typography>
          {!children ? (
            <ModalChildern>
              <Button
                size="sm"
                variant="secondary"
                style={{ width: '100px' }}
                onClick={onOk}
                isLoading={loading}
                isDisabled={loading}
              >
                <Typography variant="normal" fontColor="white">
                  {okText}
                </Typography>
              </Button>
              <Button
                size="sm"
                variant="cancel"
                style={{ width: '100px' }}
                onClick={handleOnClose}
                isDisabled={loading}
              >
                <Typography variant="normal">{cancelText}</Typography>
              </Button>
            </ModalChildern>
          ) : (
            children
          )}
        </ModalBody>
      }
    </Modal>
  );
};

export default ConfirmationModal;
